/**
 * Licensed Materials - Property of IBM
 * (c) Copyright IBM Corporation 2021, 2024. All Rights Reserved.
 *
 * Note to U.S. Government Users Restricted Rights:
 * Use, duplication or disclosure restricted by GSA ADP Schedule
 * Contract with IBM Corp.
 */
import React, { useContext } from "react";
import { SkeletonText } from "@carbon/react";
import { i18nContext, servicesContext } from "../table-context";
import utils from "../../../utils/property-util";
function IntegrationPropertyDisplayValue(props) {
  var isLoading = props.isLoading,
    property = props.property;
  var i18n = useContext(i18nContext);
  var toolchainServices = useContext(servicesContext);
  if (isLoading) {
    return /*#__PURE__*/React.createElement(SkeletonText, null);
  }
  var displayValue = utils.getIntegrationPropertyDisplayValue({
    i18n: i18n,
    property: property,
    toolchainServices: toolchainServices
  });
  return /*#__PURE__*/React.createElement("span", {
    className: "property-display-value-wrapper"
  }, /*#__PURE__*/React.createElement("span", {
    className: "property-display-value",
    "data-type": property.type,
    title: displayValue
  }, displayValue));
}
export default IntegrationPropertyDisplayValue;